import { Wording } from '@/types';

export const COOKING_WORDING_CY: Wording = {
  components_header_media_content: 'Βίντεο μαγειρικής',
  components_header_media_1: '',
  components_header_media_2: '',
  components_header_text1: 'Συνταγές',
  components_header_text2: 'Ιστολόγιο',
  components_header_members: 'Μέλη',
  hero_text: 'Μαγειρέψτε με πάθος, φάτε με χαρά',
  hero_button_text: 'Ξεκινήστε το μαγείρεμα σήμερα',
  components_ressources_section_title: 'ΠΟΡΟΙ',
  components_ressources_subheader_text: 'Όλοι οι πόροι που χρειάζεστε για να μάθετε, να μαγειρέψετε και να δημιουργήσετε καλύτερο φαγητό',
  components_ressources_span_text: 'Ανακαλύψτε μια πλούσια συλλογή από βίντεο συνταγών, λεπτομερείς οδηγούς μαγειρικής και εξειδικευμένες γνώσεις σχετικά με τους συνδυασμούς γεύσεων, την παρουσίαση φαγητού και τη μαγειρική δημιουργικότητα.',
  components_ressources_card_1_title: 'Έμπνευση για τη μαγειρική',
  components_ressources_card_1_text: 'Εμπνευστείτε από δημιουργικές συνταγές και βίντεο μαγειρικής.',
  components_ressources_card_2_title: 'Γνώσεις μαγειρικής',
  components_ressources_card_2_text: 'Μάθετε βασικές τεχνικές μαγειρικής, συνδυασμούς γεύσεων και βασικά στοιχεία για το ταίριασμα φαγητού μέσα από σαφείς, πρακτικούς οδηγούς.',
  components_ressources_link: 'Παρακολουθήστε βίντεο',
  components_notes_and_google_title_1: 'Εκπαίδευση Μαγειρικής',
  components_notes_and_google_title_2: 'Καθημερινό Μαγειρική',
  components_notes_and_google_title_3: 'Συνεπείς Μαγειρικές Δεξιότητες',
  components_review_google_text: 'Κριτικές στην Google',
  media_content_section_title: 'Βίντεο μαγειρικής',
  media_content_section_subheader_text: 'Εξερευνήστε συνταγές και βίντεο μαγειρικής βήμα προς βήμα.',
  text_media_1: '',
  text_media_2: '',
  media_content_section_button_more: 'Περισσότερα βίντεο',
  text2_section_title: 'ΙΣΤΟΛΟΓΙΟ',
  text2_section_subheader_text: 'Οδηγοί & Άρθρα',
  text2_section_button_more: 'Περισσότερα άρθρα',
  components_text1_section_title: 'ΣΥΝΤΑΓΕΣ',
  components_text1_subheader_text: 'Νόστιμες συνταγές για καθημερινό μαγείρεμα',
  components_text1_span_text: 'Ανακαλύψτε εύκολες συνταγές σχεδιασμένες για καθημερινά γεύματα, με σαφή βήματα και εξαιρετικά αποτελέσματα.',
  components_text1_card_1_title: 'Ξεκινήστε τη μέρα σας σωστά',
  components_text1_card_1_text: 'Απλές και νόστιμες συνταγές για να ξεκινήσετε τη μέρα σας με άνεση και νοστιμιά.',
  components_text1_card_3_title: 'Ιδέες για γευστικό μεσημεριανό γεύμα',
  components_text1_card_3_text: 'Νόστιμες συνταγές για μεσημεριανό γεύμα, εύκολες στην προετοιμασία και γεμάτες γεύση.',
  components_text1_card_2_title: 'Συνταγές για χορταστικό δείπνο',
  components_text1_card_2_text: 'Ζεστές, χορταστικές συνταγές για δείπνο, ιδανικές για χαλαρά βράδια στο σπίτι.',
  components_text1_link: 'Δείτε όλες τις συνταγές',
  components_footer_text: 'Μάθετε Καλύτερη Μαγειρική, Δημιουργήστε Καλύτερο Φαγητό: Η Κουζίνα σας, το Ταξίδι σας.',
  components_footer_info: 'Πληροφορίες',
  components_footer_registration_number: 'Αριθμός καταχώρισης',
  components_footer_legal: 'Νομικός',
  components_footer_terms: 'Όροι και Προϋποθέσεις',
  components_footer_privacy: 'Πολιτική Απορρήτου',
  button_load_more: 'Φόρτωση περισσότερων',
  page_media_1_content_hero_text: 'Ανακαλύψτε εύκολα βίντεο μαγειρικής για κάθε γούστο',
  page_text1_hero_text: 'Συνταγές',
  page_text1_section_title: 'Συμβουλές μαγειρικής',
  page_text1_subheader_text: 'Συνταγές',
  page_text2_hero_text: 'Το ιστολόγιό μας',
  page_text2_section_title: 'Ιστολόγιο',
  page_text2_subheader_text: 'Οδηγοί & Άρθρα',
  enter_email_title: 'Παρακαλώ εισάγετε το email σας για να συνεχίσετε',
  enter_email_placeholder_email: 'E-mail',
  enter_email_button_enter: 'Εισάγω',
  components_login_success_text: 'Η σύνδεση ήταν επιτυχής!',
  components_card_link_media_content: 'Παρακολουθήστε τώρα',
  components_card_link_text1_content: 'Δείτε τη συνταγή',
  components_card_link_text2_content: 'Δείτε το άρθρο',
};